import React from 'react';

export default function DataDrivenMockServicesVideo() {
  return (
    <div>
      <div className="wistia_responsive_padding">
        <div className="wistia_responsive_wrapper">
          <iframe
            src="https://www.youtube.com/embed/7Haxr0L6z-w"
            title="Data Driven Virtual Services"
            scrolling="no"
            className="wistia_embed"
            name="wistia_embed"
            allowFullScreen
            width="100%"
            height="100%"
          />
        </div>
      </div>
    </div>
  );
}
